import React, { useContext, useEffect, useState } from "react";
import "admin-lte/dist/css/adminlte.min.css";
import "../../../assets/AdminCss/dashboard.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretDown, faCaretLeft } from "@fortawesome/free-solid-svg-icons";

import { Link, useNavigate } from "react-router-dom";
import { AuthContext, base_url } from "../../../context/Authcontext";
import axios from "axios";
import PreloaderAdmin from "../../PreloaderAdmin";



const AdminSidebar = ({ isSidebarOpen, toggleSidebar, isMobile }) => {
  const navigate = useNavigate();
  const [key, setKey]= useState({name:'',role:''});
  const [isPagesOpen, setIsPagesOpen] = useState({});
  const { getRoles }= useContext(AuthContext);
  const [sideListItems, setSideListItems] = useState(
    [

      {
        Name: "Whitelist",
        iconName: "nav-icon fa fa-list-check",
        List: [
          {
            Name: "Agent Whitelist",
            url: "/admin/agentWhitelist",
            iconName: "nav-icon fa fa-clipboard-check",
            isAllowed: false
          },
          {
            Name: "Customer Whitelist",
            url: "/admin/customerWhitelist",
            iconName: "nav-icon fa fa-user-check",
            isAllowed: false
          },
        ],
        isAllowed: false,
      },

      {
        Name: "Payment",
        iconName: "nav-icon fa fa-credit-card",
        List: [
          
          {
            Name: "Pending Recharge",
            url: "/admin/browse_recharge",
            iconName: "nav-icon fa fa-hourglass-half",
            isAllowed: false
          },
          {
            Name: "Recharge History",
            url: "/admin/deposit_history",
            iconName: "nav-icon fa fa-file-invoice-dollar",
            isAllowed: false
          },
          {
            Name: "Recharge",
            url: "/admin/adminRecharge",
            iconName: "nav-icon fa fa-credit-card",
            isAllowed: false
          },
          {
            Name: "Bank",
            url: "/admin/settings",
            iconName: "nav-icon fa fa-university",
            isAllowed: false
          },
          
        ],
        
        isAllowed: false,
      },
      
      {
        Name: "Roles",
        url: "/admin/roles",
        iconName: "nav-icon fa fa-users-cog",
        isAllowed: false,
      },

      {
        Name: "Currency",
        url: "/admin/currency",
        iconName: "nav-icon fa fa-users-cog",
        isAllowed: false,
      },
      
      {
        Name: "Reports",
        iconName: "nav-icon fa fa-file-text",
        List: [
          
          {
            Name: "Casino Bets",
            url: "/admin/casinoReport",
            iconName: "nav-icon fa fa-dice",
            isAllowed: false
          },
          {
            Name: "Client Wallet Report",
            url: "/admin/clientWallet",
            iconName: "nav-icon fa fa-money-bill-wave",
            isAllowed: false
          },
          {
            Name: "Chips Report",
            url: "/admin/chipsReport",
            iconName: "nav-icon fa fa-database",
            isAllowed: false
          },
          {
            Name: "Admin Chips Report",
            url: "/admin/adminchipsReport",
            iconName: "nav-icon fa fa-database",
            isAllowed: false
          },

           {
            Name: "Turnkey History",
            url: "/admin/turnkeyHistory",
            iconName: "nav-icon fa fa-database",
            isAllowed: false
          },
          {
            Name: "GGR Report",
            url: "/admin/ggrReport",
            iconName: "nav-icon fa fa-database",
            isAllowed: false
          },
          {
            Name: "Agent chip Report",
            url: "/admin/account",
            iconName: "nav-icon fa fa-database",
            isAllowed: false
          },
          
        ],
        
        isAllowed: false,
      },
      {
        Name: "deletecustomer",
        url: "/admin/DeleteCustomers",
        iconName: "nav-icon fa fa-users-cog",
        isAllowed: false,
      },
      

     {
  Name: "customerHistory",   // must match backend key
    url: "/admin/customer/deposit_history",
  iconName: "nav-icon fa fa-history",
   isAllowed: false,
 
}


    ]
  );
  

  const handleLogout = () => {
    navigate("/");
    localStorage.removeItem("admin");
  };

  const fetchUser=async(req,res)=> {
    const auth= localStorage.getItem('admin');

    try{

      const response= await axios.get(base_url + "/api/webapi/loggedUser",
        {
          headers : {
            "Content-Type" : "application/json",
            Authorization : `${auth}`
          }
        }
      )

      const name= response.data.username.username;
      const role= response?.data.username.role;
      setKey({name:name, role:role});

    }catch(err){
      console.log('err',err);
    }
  }

  const handleClick= (list)=> {

    if(list.url){
      navigate(list.url);
      
    }else if(list.List){
      setIsPagesOpen((prev)=> ({
        ...prev,
        [list.Name]: !prev[list.Name]
      }))
    }
    
  };

  const fetchRoles= async()=> {
    const auth= localStorage.getItem('admin');
    const role= localStorage.getItem('role');

    try{
      const roles= await getRoles(auth, role);
      // console.log('admin',roles);
      const permitRole= roles[0];
      const key= Object.keys(permitRole);
      setKey(key[0]);
      const arr= permitRole[key];
      // console.log('aer',arr);
      const allowedKeys=[]
      const allowedValues=[]

      arr.map(item=> {
        const k= Object.keys(item);
        const valuess= Object.values(item);

        allowedKeys.push(k[0]);
        allowedValues.push(valuess[0]);
    })

    const allowed=[]
    
    allowedValues.forEach(allow => 
      allow.forEach(values=> allowed.push(values.toLowerCase()))
    );

    // console.log('alfthg',allowed);    
    
    setSideListItems((prevItems) =>
      prevItems.map((item) => ({
        ...item,
        isAllowed: allowedKeys.includes(item.Name.toLowerCase()), // Check parent permission
    
        List: item.List
          ? item.List.map((subItem) => ({
              ...subItem,
              isAllowed: allowed.includes(subItem.Name.toLowerCase()), // Check child permission
            }))
          : item.List, // If no List, return as is
      }))
    );


    }catch(err){
      console.log('erd',err);
    }
  }

  const roleName= async(req, res)=> {
    const auth = localStorage.getItem('admin');

    try{
      const response= await axios.post(base_url+ '/api/webapi/admin/Rolelist',
        {},
        {
          headers:{
            Accept: 'application/json',
            Authorization: `${auth}`
          }
        }
      )

      const fullRoles= response.data.data;

      let arr=[];

      fullRoles?.map(full=> {
        const keyy= Object.keys(full);

        arr.push(keyy[0]);
        // console.log('kuyy',keyy[0]);
      });

      return arr;

    }catch(err){
      console.log('err',err);
    }
  }

  const updateSidebarWithRoles = (roleNames) => {
    const roleHierarchy = [
      // "Super admin",
      // "Admin",
      // "Super master",
      // "Master",
      // "Agent",
      "User"
  ];

  const normalRoles= roleNames.map(role=> role.toLowerCase());


  const hierarchy= roleHierarchy.map(role=> role.toLowerCase());


  const verified= hierarchy.filter(hier=> normalRoles.includes(hier));


    setSideListItems(prevItems => {
        return prevItems?.map(item => {
            if (item.Name === 'User') {
                return {
                    ...item,
                    List: verified.map(itemName => ({
                        Name: itemName,
                        url: `/admin/${itemName.toLowerCase().replace(/\s+/g, '')}`,
                        isAllowed: false
                    }))
                };
            }
            return item;
        });
    });
  };

  useEffect(() => {
      const initializeSidebar = async () => {
          try {
              const roleNames = await roleName();
              updateSidebarWithRoles(roleNames);
              await fetchUser();
          } catch (error) {
              console.error("Error initializing sidebar:", error);
          }
      };

      initializeSidebar();
      fetchRoles();
  }, []);


  return (
    <>
    {isMobile && isSidebarOpen && (
        <div 
          className="sidebar-overlay" 
          onClick={toggleSidebar}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "linear-gradient(45deg, rgb(19 244 255), rgb(128 196 255))",
            zIndex: 1040,
          }}
        />
      )}
    
    <aside
      className={`main-sidebar  elevation-4 fs-6 sidebar-scroll-hidden ${
        isSidebarOpen ? "sidebar-open" : "sidebar-collapse"
      }`}
      style={{
        zIndex: 1050,
        transition: "transform 0.3s ease-in-out",
        position: "fixed", // Make sure the sidebar is fixed
        height: "100%",
        overflowY: "auto",
        background: "linear-gradient(45deg, rgb(19 244 255), rgb(128 196 255))",
        // On small screens, use transform to slide in/out
        transform: window.innerWidth <= 768 && !isSidebarOpen ? "translateX(-100%)" : "translateX(0)",
      }}
    >

     
      {/* Brand Logo */}
      <p className="brand-link align-items-center brand-link d-flex justify-content-start gap-3 ml-4 cursor-pointer" >
        <Link
            data-target="nav-mobile"
            className="sidenav-trigger1"
            onClick={toggleSidebar}
          >
            <img
              src="/assets/images/Xcross.svg"
              alt="Close Menu"
              className="cross-icon"
            />
          </Link>
        <img src="/assets/images/avatar.svg" alt="" style={{ width: "40px" }} onClick={()=> navigate('/admin/Profile')} />
        {isSidebarOpen && (
          <span className="brand-text fs-6 text-white">
            {key.name} | {key.role}
          </span>
        )}
      </p>

      {/* Sidebar */}
      <div className="sidebar">
        {/* Sidebar Menu */}
        <nav className="mt-2">
          <ul className="nav nav-pills nav-sidebar flex-column" role="menu">
            {/* Dashboard */}
            <li className="nav-item" onClick={()=> navigate('/admin/dashboard')}>
              <Link to="#" className=" nav-link gap-2 text-white ">
                <i className={`nav-icon fa fa-home`}></i>
                {isSidebarOpen && <p className="fs-6">Dashboard</p>}
              </Link>
            </li>
            {sideListItems.map((list, index) => {
              // console.log('list is',list);
              return (
                <li
                  key={index}
                  className={`nav-item ${list.isAllowed ? "d-block" : "d-none"}`}
                  onClick={() => {handleClick(list)}}
                >
                  <Link
                    to="#"
                    className=" nav-link d-flex gap-2 text-white "
                  >
                    <i className={`${list.iconName} fs-6`}></i>
                    {isSidebarOpen && (
                      <p className="fs-6">{list.Name}</p>
                    )}
                    {list.Name === "Reports" && (
                      <FontAwesomeIcon
                        icon={isPagesOpen ? faCaretDown : faCaretLeft}
                        className="dropdown-icon ms-auto"
                      />
                    )}
                    

                    {list.Name=== 'Payment' && (
                      <FontAwesomeIcon
                      icon={isPagesOpen ? faCaretDown : faCaretLeft}
                      className="dropdown-icon ms-auto"
                    />
                    )}
                    {list.Name=== 'Whitelist' && (
                      <FontAwesomeIcon
                      icon={isPagesOpen ? faCaretDown : faCaretLeft}
                      className="dropdown-icon ms-auto"
                    />
                    )}
                  </Link>



                  
                  
                  {list.Name === "Payment" && isPagesOpen[list.Name] &&
                        list.List
                          .filter((uList) => uList.isAllowed) // Show only allowed items
                          .map((uList, id) => {
                            return (
                              <ul
                                key={id}
                                className={`nav nav-treeview pl-3 ${isPagesOpen ? "show" : ""}`}
                              >
                                <li
                                  className="nav-item"
                                  onClick={() => navigate(`${uList.url}`)}
                                >
                                  <Link
                                    to="#"
                                    className="nav-link text-white "
                                  >
                                    <i className={`${uList.iconName} fs-6`}></i>
                                    <p className="fs-6">
                                      {uList.Name}
                                    </p>
                                  </Link>
                                </li>
                              </ul>
                            );
                          })}

                      {list.Name === "Reports" && isPagesOpen[list.Name] &&
                        list.List
                          .filter((uList) => uList.isAllowed) // Show only allowed items
                          .map((uList, id) => {
                            return (
                              <ul
                                key={id}
                                className={`nav nav-treeview pl-3 ${isPagesOpen ? "show" : ""}`}
                              >
                                <li
                                  className="nav-item"
                                  onClick={() => navigate(`${uList.url}`)}
                                >
                                  <Link
                                    to="#"
                                    className="nav-link text-white "
                                  >
                                    <i className={`${uList.iconName} fs-6`}></i>
                                    <p className="fs-6">
                                      {uList.Name}
                                    </p>
                                  </Link>
                                </li>
                              </ul>
                            );
                          })}

                          {list.Name === "Whitelist" && isPagesOpen[list.Name] &&
                        list.List
                          .filter((uList) => uList.isAllowed) // Show only allowed items
                          .map((uList, id) => {
                            return (
                              <ul
                                key={id}
                                className={`nav nav-treeview pl-3 ${isPagesOpen ? "show" : ""}`}
                              >
                                <li
                                  className="nav-item"
                                  onClick={() => navigate(`${uList.url}`)}
                                >
                                  <Link
                                    to="#"
                                    className=" nav-link text-white "
                                  >
                                    <i className={`${uList.iconName} fs-6`}></i>
                                    <p className="fs-6">
                                      {uList.Name}
                                    </p>
                                  </Link>
                                </li>
                              </ul>
                            );
                          })}

                          
                </li>
              );
            })} 
            <li className="nav-item" onClick={handleLogout}>
              <Link to="#" className=" nav-link gap-2 text-white">
                <i className={`nav-icon fa fa-sign-out`}></i>
                {isSidebarOpen && <p className="fs-6">Log Out</p>}
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    </aside>
    </>
  );
};

export default AdminSidebar;
